import React from 'react';
import {
  getActivePrimaryDigitalTrial,
  getLapsedDigitalTrial,
} from '@engage/subscriptions/Subscription';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';
import { toSubscriptionsUrl } from '@members/routes/preferences';
import { WELCOME_PATH, PASSWORD_PATH } from '@members/routes/profile-setup';
import { LIVE_VIDEO_ROUTE, VIDEO_ON_DEMAND_ROUTE } from '@members/routes/video';
import { useAllSubscriptions } from '@members/subscriptions/hooks/useAllSubscriptions';
import { ExpiringSoon } from './ExpiringSoon';
import { LapsedTrial } from './LapsedTrial';

const BLACKLIST_PATHS = [
  VIDEO_ON_DEMAND_ROUTE,
  LIVE_VIDEO_ROUTE,
  toSubscriptionsUrl(),
  WELCOME_PATH,
  PASSWORD_PATH,
];

const isBlacklisted = (pathname: string) =>
  BLACKLIST_PATHS.some(path => pathname.startsWith(path));

export const GlobalFreeTrialBanner = () => {
  const { asPath } = useRouter();
  const subscriptions = useAllSubscriptions();
  if (isBlacklisted(asPath)) {
    return null;
  }
  if (!subscriptions) {
    return null;
  }
  const lapsedDigitalTrial = getLapsedDigitalTrial(subscriptions);
  const activePrimaryDigitalTrial = getActivePrimaryDigitalTrial(subscriptions);
  if (lapsedDigitalTrial) {
    return <LapsedTrial lapsedDigitalTrial={lapsedDigitalTrial} />;
  }
  if (activePrimaryDigitalTrial) {
    return <ExpiringSoon activePrimaryDigitalTrial={activePrimaryDigitalTrial} />;
  }
  return null;
};
